/**
 * Hook to fetch and manage company bank accounts
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getBankAccounts, addBankAccount } from '../api/facturation.api';

export const bankAccountKeys = {
  all: ['bank-accounts'] as const,
};

export const useBankAccounts = () => {
  return useQuery({
    queryKey: bankAccountKeys.all,
    queryFn: getBankAccounts,
    staleTime: 5 * 60 * 1000, // 5 minutes — bank accounts rarely change
  });
};

export const useAddBankAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { label: string; iban: string; bic: string; bankName?: string }) =>
      addBankAccount(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bankAccountKeys.all });
    },
  });
};
